import {type FunctionalComponent, h} from '@stencil/core';
import type {IDashboardItemHeader} from '../../types/subcomponents-types.type';

export const DashboardItemHeader: FunctionalComponent<IDashboardItemHeader> = (
  props
) => {
    const { labelProvider, title, tabCount, targetTab, subTitle, privateCard, itemCount, term, mobileView } =
    props;

    const subtitleText = 'Showing {0} of {1} results for {2}';
    const labelText = subTitle
      ? labelProvider('dashboard.tile.description-informative', subtitleText)
      : '';

    const formatResultString = ()=>{
        try{
          return labelText
            .replace('{0}', itemCount.toString() )
            .replace('{1}', tabCount.toString())
            .replace('{2}', term ? term.toString() : '');
        }catch(e){
          return '';
        }
    };



    return (
      <section class="item-header">
        <qds-title
          layer="accessory"
          level="section"
          kicker={privateCard ? labelProvider('badge.myContent', 'My Content') : ''}
          subtitle={!mobileView ? formatResultString() : ''}>
          <strong>{title}</strong>
        </qds-title>
        <uiaas-dashboard-tab-button
          labelProvider={(e, f) => props.labelProvider(e, f)}
          targetTab={targetTab}
          isMobile={mobileView}
        />
      </section>
    );
};
